import axios from 'axios';
import AsyncStorage from '@react-native-async-storage/async-storage';
import {
  FETCH_SAVED_FILTERS_SUCCESS,
  FETCH_SAVED_FILTERS_FAIL,
  CREATE_SAVED_FILTER_SUCCESS,
  UPDATE_SAVED_FILTER_SUCCESS,
  DELETE_SAVED_FILTER_SUCCESS
} from '../constants';

export function fetchSavedFilters() {
  return async dispatch => {
    try {
      const access_token = await AsyncStorage.getItem('access_token');
      const url = await AsyncStorage.getItem('url');
      const response = await axios.get(`${url}/saved_filters.json`, {
        headers: {Authorization: `Bearer ${access_token}`}
      });

      dispatch({
        type: FETCH_SAVED_FILTERS_SUCCESS,
        payload: response.data
      });
    } catch (error) {
      dispatch({
        type: FETCH_SAVED_FILTERS_FAIL,
        payload: error?.response?.status
      });
    }
  };
}

export function createSavedFilter({name, filters, isFavourite = false}, callBack) {
  return async dispatch => {
    try {
      const access_token = await AsyncStorage.getItem('access_token');
      const url = await AsyncStorage.getItem('url');
      const response = await axios.post(
        `${url}/saved_filters.json`,
        {
          saved_filter: {
            name,
            filters,
            isFavourite
          }
        },
        {
          headers: {Authorization: `Bearer ${access_token}`}
        }
      );

      dispatch({
        type: CREATE_SAVED_FILTER_SUCCESS,
        payload: response.data
      });

      if (callBack) {
        callBack(null, response.data);
      }
    } catch (error) {
      dispatch({
        type: FETCH_SAVED_FILTERS_FAIL,
        payload: error?.response?.status
      });

      if (callBack) {
        const message =
          error?.response?.data?.errors?.join(', ') ||
          'Unable to save filter';
        callBack(message);
      }
    }
  };
}

export function updateSavedFilter(id, updates, callBack) {
  return async dispatch => {
    try {
      const access_token = await AsyncStorage.getItem('access_token');
      const url = await AsyncStorage.getItem('url');
      const response = await axios.put(
        `${url}/saved_filters/${id}.json`,
        {
          saved_filter: updates
        },
        {
          headers: {Authorization: `Bearer ${access_token}`}
        }
      );

      dispatch({
        type: UPDATE_SAVED_FILTER_SUCCESS,
        payload: response.data
      });

      if (callBack) {
        callBack(null, response.data);
      }
    } catch (error) {
      dispatch({
        type: FETCH_SAVED_FILTERS_FAIL,
        payload: error?.response?.status
      });

      if (callBack) {
        callBack(error);
      }
    }
  };
}

export function deleteSavedFilter(id, callBack) {
  return async dispatch => {
    try {
      const access_token = await AsyncStorage.getItem('access_token');
      const url = await AsyncStorage.getItem('url');
      await axios.delete(`${url}/saved_filters/${id}.json`, {
        headers: {Authorization: `Bearer ${access_token}`}
      });

      dispatch({
        type: DELETE_SAVED_FILTER_SUCCESS,
        payload: id
      });

      if (callBack) {
        callBack(null);
      }
    } catch (error) {
      dispatch({
        type: FETCH_SAVED_FILTERS_FAIL,
        payload: error?.response?.status
      });

      if (callBack) {
        callBack(error);
      }
    }
  };
}

